module.exports = __webpack_public_path__ + "static/media/mainxxhdpi.53f22f3c.png";